<template>
    <main>
        <section>
            <div class="align-content-center m-4">
                <!-- <h3>Welcome _Hella</h3> -->
                <div class="page_title" style="display: flex;justify-content: center;">
                    <div>
                        <h3 class="page_title" style="display: inline-block;
                    height: 4.1rem;
                    border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Project Pogress </h3>
                    </div>

                </div>

            </div>
        </section>
        <section>
            <div style="width: 100%;margin: 0 auto;">
                <table style="width: 100%;background-color: #1D1D1B;margin: 0 auto;min-height: 800px;">
                    <tr>

                        <td class="col-md-3"
                            style="vertical-align: top; padding: 0;background-color: transparent;border-right: 1px solid #424242;">
                            <div class="tree-box" style="width: 100%;">
                                <div
                                    style=" height: 40px;background-color: #434343;text-align: center; line-height: 40px;">
                                    <div class="custom-header" style=" display: flex;text-align: center;">
                                        <div style="position: relative;text-align: center;width: 100%;">
                                            <table style="width: 100%;">
                                                <tr>
                                                    <td>Classification</td>
                                                    <td style="width: 120px;">Start</td>
                                                    <td style="width: 130px;">Complete</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <!-- <div style="position: absolute;">
                                        <img src="../../../public/assets/img/Main/treeGroupExp.png" v-if="!isLeftExp" class="header-image" style=" margin-left: 8px; max-height: 15px;" @click="Expandcollapse(0)"/>
                                        <img src="../../../public/assets/img/Main/treeGroupCol.png" v-if="isLeftExp" class="header-image" style=" margin-left: 8px; max-height: 15px;" @click="Expandcollapse(0)"/>
                                    </div> -->

                                    </div>
                                </div>

                            </div>
                            <div class="tree-content" style="margin-top: 10px;">
                                <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line" v-if="treeData.length > 0"
                                    :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                                    @cell-style="{color:red}" :default-expand-all="isLeftExp" :highlight-current="false" :default-expanded-keys="expandedKeys"
                                    :expand-on-click-node="false" @node-click="handleNodeClick">
                                    <span slot-scope="{ data }" class="custom-tree-node">
                                        <template>

                                            <div class="node_div" style="display: flex;align-items: center;">
                                                <span style="flex:1;text-align: left;">
                                                    {{ data.code }}
                                                </span>
                                                <span style="width: 110px;text-align: left;">
                                                    {{ data.date1 }}
                                                </span>
                                                <span style="width: 110px;text-align: left;">
                                                    {{ data.date2 }}
                                                </span>

                                            </div>
                                        </template>
                                    </span>
                                </el-tree>
                                <p v-if="treeData.length === 0" style="color: #6E7175;">
                                    No Data Available
                                  </p>
                            </div>
                        </td>
                        <td class="container col-md-10-1" style="vertical-align: top;padding: 0;">
                            <div class="tree-box" style="width: 100%;">
                                <div
                                    style=" height: 40px;background-color: #434343;text-align: center; line-height: 40px;">
                                    <div class="custom-header" style=" display: flex;text-align: center;">
                                        <div style="position: relative;text-align: center;width: 100%;">
                                            <table style="width: 100%;">
                                                <tr>
                                                    <td>Name</td>
                                                    <td style="width: 120px;">StartDate</td>
                                                    <td style="width: 120px;">EndDate</td>
                                                    <td style="width: 210px;">Schedule</td>
                                                    <td style="width: 200px;">Remarks</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <!-- <div style="position: absolute;">
                                        <img src="../../../public/assets/img/Main/treeGroupExp.png" v-if="!isLeftExp" class="header-image" style=" margin-left: 8px; max-height: 15px;" @click="Expandcollapse(1)"/>
                                        <img src="../../../public/assets/img/Main/treeGroupCol.png" v-if="isLeftExp" class="header-image" style=" margin-left: 8px; max-height: 15px;" @click="Expandcollapse(1)"/>
                                    </div> -->

                                    </div>
                                </div>
                            </div>
                            <div class="tree-content" style="margin-top: 10px;overflow: hidden;">
                                <el-tree ref="treeRight" :data="data" node-key="id" :indent="0" class="tree-line" v-if="treeData.length > 0"
                                    :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                                    :default-expand-all="isRightExp" :expand-on-click-node="true">
                                    <span slot-scope="{ data }" class="custom-tree-node">
                                        <template>
                                            <div style="display: flex;align-items: center;">
                                                <span style="flex:1;text-align: left;">
                                                    {{ data.name }}
                                                </span>
                                                <span style="width: 110px;text-align: left;">
                                                    {{ data.date1 }}
                                                </span>
                                                <span style="width: 110px;text-align: left;">
                                                    {{ data.date2 }}
                                                </span>
                                                <el-progress v-if="data.realID>0" :percentage="data.itemNum"
                                                    :text-inside="true" :color="'#1ED218'" :stroke-width="15"
                                                    style="display:inline-block;width:180px;"> </el-progress>
                                                <span style="width: 200px;text-align: left;">
                                                    {{ data.remark }}
                                                </span>
                                            </div>
                                        </template>
                                    </span>
                                </el-tree>
                                <p v-if="treeData.length === 0" style="color: #6E7175;">
                                    No Data Available
                                  </p>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </section>



        <!-- <section class="row mx-0" style="background:#1D1D1B;border-bottom: 1px solid #424242;min-height: 600px;">
        
        <div class="col-md-3"  style="border-right:1px solid #424242;">
            <el-table :data="treeData" style="width: 100%" row-key="id"  highlight-current-row
                :tree-props="{ children: 'children' }"
                default-expand-all :header-cell-style="{padding:0,height:'30px',backgroundColor:'#434343',border:0,color:'white','text-align':'center'}" 
                :cell-style="{padding:0,border:0,backgroundColor:'#1D1D1B'}"
                >
                <el-table-column prop="name" label="Classification" width="cale(100%-250)"></el-table-column>
                <el-table-column prop="value" label="Set Up Date" width="100"></el-table-column>
                <el-table-column prop="description" label="Completion Date" width="150"></el-table-column>
            </el-table>
        </div>
        <div class="col-md-9" >
            <el-table :data="data" style="width: 100%" row-key="id"  highlight-current-row
                        :tree-props="{ children: 'children' }"
                        default-expand-all :header-cell-style="{padding:0,height:'30px',backgroundColor:'#434343',border:0,color:'white','text-align':'center'}" 
                        :cell-style="{padding:0,border:0,backgroundColor:'#1D1D1B'}"
                        >
                        <el-table-column prop="name" label="Task Description" width="420"></el-table-column>
                        <el-table-column prop="startDate" label="Dispatch Date" width="130"></el-table-column>
                        <el-table-column prop="endDate" label="Completion Date" width="135"></el-table-column>
                        <el-table-column label="Schedule" width="200">
                            <template slot-scope="scope">
                            <el-progress v-if="scope.row.isProgress" :percentage="scope.row.progress" :text-inside="true" :color="'#1ED218'" :stroke-width="15" 
                            style="display:inline-block;width:180px;"> </el-progress>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remarks" label="Remark" width="cale(100%-865)"></el-table-column>
                    </el-table>
        </div>
</section> -->
    </main>

</template>

<script>
    import { getProjectNodeTree, getPrjectLeftTree } from "@/api/rbac/project";
    export default {
        data() {
            return {
                treeData: [{
                    id: 1,
                    name: 'Uncompleted',
                    value: '',
                    description: '',
                    children: [
                        {
                            id: 3,
                            name: '*6246-024-009',
                            value: '2025-01-09',
                            description: '2025-02-03'
                        },
                    ]
                }, {
                    id: 6,
                    name: 'Completed',
                    value: '',
                    description: '',
                    children: [{
                        id: 8,
                        name: '*6246-024-009',
                        value: '2025-01-09',
                        description: '2025-02-03'
                    }, {
                        id: 9,
                        name: '*6246-024-009',
                        value: '2025-01-09',
                        description: '2025-02-03'
                    }]
                }
                ],
                data: [{
                    id: 1,
                    name: 'Q0 Phase-Business Evaluation',
                    children: [{
                        id: 2,
                        name: 'Set up project team',
                        children: [{
                            id: 3,
                            name: 'Identify team members and functions',
                            startDate: '2025-01-09',
                            endDate: '2025-01-30',
                            progress: 70,
                            remarks: '',
                            isProgress: true,
                        }]
                    }]
                }, {
                    id: 4,
                    name: 'Q0 Phase-Business Evaluation',
                    children: [{
                        id: 5,
                        name: 'Set up project team',
                        children: [{
                            id: 6,
                            name: 'Identify team members and functions',
                            startDate: '2025-01-09',
                            endDate: '2025-01-30',
                            progress: 20,
                            remarks: '',
                            isProgress: true,
                        }, {
                            id: 7,
                            name: 'Identify team members and functions',
                            startDate: '2025-01-09',
                            endDate: '2025-01-30',
                            progress: 50,
                            remarks: '',
                            isProgress: true,
                        }, {
                            id: 8,
                            name: 'Identify team members and functions',
                            startDate: '2025-01-09',
                            endDate: '2025-01-30',
                            progress: 90,
                            remarks: '',
                            isProgress: true,
                        }]
                    }]
                }],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                isLeftExp: true,
                isRightExp: true,
                expandedKeys:[],
            };
        },
        computed: {
            user() {
                return this.$store.state.user; // 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
            },
        },
        created() {
            this.getTreeLeft()
        },
        methods: {
            getTreeLeft() {
                var strWhere = ''
                if (!this.user) {
                    strWhere = ' and 1=2'
                }
                else {
                    strWhere = ' and b.id=' + this.user.id
                }
                getPrjectLeftTree({ strWhere: strWhere }).then(res => {
                    this.treeData = res.data;
                    if (res.data.length == 0) {
                        this.data = []
                    }
                    else {
                        if (this.treeData.length > 0 && this.treeData[0].children.length > 0) {
                            var node = this.treeData[0].children[0]
                            this.$nextTick(() => {
                                this.$refs.treeleft.setCurrentKey(this.treeData[0].children[0].id);
                            });
                        }
                        //右侧树
                        // this.handleNodeClick(node)
                        this.getProjectNode(' and projectID=' + node.realID)

                    }
                })
            },
            getProjectNode(strWhere) {
                getProjectNodeTree({ strWhere: strWhere }).then(res => {
                    this.data = res.data;
                })
            },
            handleNodeClick(node) {
                if (node.children && node.children.length > 0) {
                    return alert('Please click a child node')
                }
                this.getProjectNode(' and projectID=' + node.realID)
            },
            Expandcollapse(tree) {
                if (tree == 0) {
                    this.isLeftExp = !this.isLeftExp;
                    const nodes = this.$refs.treeleft.store._getAllNodes();
                    for (let key in nodes) {
                        nodes[key].expanded = this.isLeftExp;
                    }
                }
                if (tree == 1) {
                    this.isRightExp = !this.isRightExp;
                    const nodes = this.$refs.treeRight.store._getAllNodes();
                    for (let key in nodes) {
                        nodes[key].expanded = this.isRightExp;
                    }
                }
            },
        }
    };
</script>

<style scoped>
    .tree-line {
        background-color: transparent;
        color: #D9D9D9;
    }

    ::v-deep .el-tree-node.is-current>.el-tree-node__content {
        background: #FCB42E !important;
        color: black;
    }

    .custom-tree-node {
        width: 100%;
        font-size: 14px;

        .node_div {
            display: flex;
            align-items: center;

            span {
                text-align: center;

                &.name-box {
                    flex: 1;
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden;
                    color: #BBBBBB;
                    text-overflow: ellipsis;
                    font-weight: normal;

                }

                &.size-box {
                    width: 120px;
                    text-align: center;
                }

                &.secret-box {
                    width: 130px;
                    text-align: center;
                }
            }
        }
    }



    .el-progress {
        display: inline-block;
        /* 或者其他布局方式 */
        width: 100%;
        /* 根据需要调整宽度 */
        margin-left: 10px;
        /* 根据需要调整间距 */
        border-radius: 2px;
    }

    :deep(div.el-progress-bar__outer) {
        border-radius: 0px;
    }

    :deep(div.el-progress-bar__inner) {
        border-radius: 0px;
    }

    .el-table::before {
        background-color: transparent;
    }

    :deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
        background-color: #FCB42E !important;
    }

    :deep(table td) {
        padding-top: 0px;
    }
</style>